import { render, staticRenderFns } from "./MoreOptionsMenu.vue?vue&type=template&id=7606cc88&scoped=true&"
import script from "./MoreOptionsMenu.vue?vue&type=script&lang=js&"
export * from "./MoreOptionsMenu.vue?vue&type=script&lang=js&"
import style0 from "./MoreOptionsMenu.vue?vue&type=style&index=0&id=7606cc88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7606cc88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7606cc88')) {
      api.createRecord('7606cc88', component.options)
    } else {
      api.reload('7606cc88', component.options)
    }
    module.hot.accept("./MoreOptionsMenu.vue?vue&type=template&id=7606cc88&scoped=true&", function () {
      api.rerender('7606cc88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MoreOptionsMenu.vue"
export default component.exports